import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';
import {DateFormat} from "../../../settings/DateFormat/DateFormat";

export const SolicitudPagoService = {
	Listar: (filtro, paginacion) => {
		let fecha_inicio = (filtro.fecha_solicitud_inicio || null) ? DateFormat.FormatSql(filtro.fecha_solicitud_inicio) : null;
		let fecha_fin = (filtro.fecha_solicitud_fin || null) ? DateFormat.FormatSql(filtro.fecha_solicitud_fin) : null;
		let params = {
			filtro: {
				no_recibo: filtro.no_recibo || null,
				usuario: filtro.usuario || null,
				proyecto: filtro.proyecto || null,
				id_cat_area_proyecto: filtro.id_cat_area_proyecto || null,
				id_cat_estatus_solicitud_pago: filtro.id_cat_estatus_solicitud_pago || null,
				fecha_solicitud_inicio: fecha_inicio,
				fecha_solicitud_fin: fecha_fin,
				activo: (Number(filtro.activo) === 1 || Number(filtro.activo) === 0) ? Number(filtro.activo) : null,
			},
			paginacion: {
				total: paginacion.total || null,
				page: paginacion.page || null,
				limit: paginacion.limit || null
			}
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Solicitud_Pago_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		
		let params = {
			id_solicitud_pago: null,
			no_recibo: form.no_recibo || '',
			id_usuario: form.id_usuario || '',
			descripcion_general: form.descripcion_general || '',
			id_cat_clasificacion_pago: form.id_cat_clasificacion_pago || '',
			id_proveedor: form.id_proveedor || '',
			id_cuenta_bancaria: form.id_cuenta_bancaria || '',
			beneficiario: form.beneficiario || '',
			banco: form.banco || '',
			numero_tarjeta: form.numero_tarjeta || '',
			id_cat_area_proyecto: form.id_cat_area_proyecto || '',
			id_cat_etapa_proyecto: form.id_cat_etapa_proyecto || '',
			id_cat_subetapa_proyecto: form.id_cat_subetapa_proyecto || '',
			id_cat_clase: form.id_cat_clase || '',
			id_cat_subclase: form.id_cat_subclase || '',
			id_cat_banco: form.id_cat_banco || '',
			id_cat_tipo_cuenta: form.id_cat_tipo_cuenta || '',
			id_cat_empresa: form.id_cat_empresa || '',
			id_cat_tipo_pago: form.id_cat_tipo_pago || '',
			observaciones: form.observaciones || '',
			partidas: form.partidas || [],
			activo: (form.activo ? 1 : 0),
			con_iva: (form.con_iva ? 1 : 0),
			
			archivo: form.archivo,
			archivo_formato: form.archivo_formato,
			archivo_nombre: form.archivo_nombre,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Solicitud_Pago_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_solicitud_pago: form.id_solicitud_pago,
			no_recibo: form.no_recibo || '',
			descripcion_general: form.descripcion_general || '',
			id_usuario: form.id_usuario || '',
			id_cat_clasificacion_pago: form.id_cat_clasificacion_pago || '',
			id_proveedor: form.id_proveedor || '',
			id_cuenta_bancaria: form.id_cuenta_bancaria || '',
			beneficiario: form.beneficiario || '',
			banco: form.banco || '',
			numero_tarjeta: form.numero_tarjeta || '',
			id_cat_area_proyecto: form.id_cat_area_proyecto || '',
			id_cat_etapa_proyecto: form.id_cat_etapa_proyecto || '',
			id_cat_subetapa_proyecto: form.id_cat_subetapa_proyecto || '',
			id_cat_clase: form.id_cat_clase || '',
			id_cat_subclase: form.id_cat_subclase || '',
			id_cat_banco: form.id_cat_banco || '',
			id_cat_tipo_cuenta: form.id_cat_tipo_cuenta || '',
			id_cat_tipo_pago: form.id_cat_tipo_pago || '',
			id_cat_empresa: form.id_cat_empresa || '',
			observaciones: form.observaciones || '',
			partidas: form.partidas || [],
			activo: (form.activo ? 1 : 0),
			con_iva: (form.con_iva ? 1 : 0),
			
			archivo: form.archivo,
			archivo_formato: form.archivo_formato,
			archivo_nombre: form.archivo_nombre,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Solicitud_Pago_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_solicitud_pago) => {
		let params = {
			id_solicitud_pago: id_solicitud_pago
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Solicitud_Pago_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	NoRecibo: () => {
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Solicitud_Pago_NoRecibo', {}).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	EstatusAgregar: (form) => {
		let usuariospago = [];
		if (form.usuarios_autorizados_pago) {
			for (let i = 0; i < form.usuarios_autorizados_pago.length; i++) {
				if (form.usuarios_autorizados_pago[i].check) {
					usuariospago.push(form.usuarios_autorizados_pago[i].id_usuario);
				}
			}
		}
		let params = {
			id_solicitud_pago: form.id_solicitud_pago,
			id_cat_estatus_solicitud_pago: form.id_cat_estatus_solicitud_pago,
			id_usuario: form.id_usuario ?? null,
			usuarios_autorizados_pago: usuariospago.length > 0 ? usuariospago : null,
			comentarios: form.comentarios ?? null
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Solicitud_Pago_Estatus', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Comprobante: (form) => {
		let fecha_pago = form.fecha_pago ? DateFormat.FormatSql(form.fecha_pago) : '';
		let params = {
			id_solicitud_pago: form.id_solicitud_pago,
			id_cat_estatus_solicitud_pago: form.id_cat_estatus_solicitud_pago,
			fecha_pago: fecha_pago,
			monto: form.monto,
			comentarios: form.comentarios,
			archivo: form.archivo,
			archivo_formato: form.archivo_formato,
			tipo_comprobante: form.tipo_comprobante
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Solicitud_Pago_Comprobante', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	EliminarComprobante: (id_solicitud_pago_comprobante) => {
		let params = {
			id_solicitud_pago_comprobante: id_solicitud_pago_comprobante
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Solicitud_Pago_Eliminar_Comprobante', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
};
